// extracted by mini-css-extract-plugin
export default {"l":"Caption_l__a-0jV","m":"Caption_m__p2zXs","s":"Caption_s__FS2yk","xs":"Caption_xs__gMzeL"};